import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "@/theme/colors";

type MuiTableContainer = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTableContainer"];
};

const muiTable: MuiTableContainer = {
  styleOverrides: {
    root: {
      boxShadow: "none",
      border: `2px solid ${ciCustomColors.blue[50]}`,
    },
  },
};

export default muiTable;
